import { render } from "./OrcidWidget.vue?vue&type=template&id=ab272156&scoped=true"
import script from "./OrcidWidget.vue?vue&type=script&lang=js"
export * from "./OrcidWidget.vue?vue&type=script&lang=js"

import "./OrcidWidget.vue?vue&type=style&index=0&id=ab272156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab272156"]])

export default __exports__